// extracted by mini-css-extract-plugin
export var documentation = "_kw-1";
export var menu = "_kw-0";